module.exports = __webpack_public_path__ + "img/bg-home.1da81a89.png";